// WMM CRM v4 — main.js
// Phase 2: V3 parity via app-legacy.js
// Sessions 06-13 will replace app-legacy.js sections with proper V4 modules.

// Core app (V3 code — full parity)
import './app-legacy.js';

// V4 module stubs — replaced session by session
import './state.js';
import './utils.js';
import { initDashboard } from './dashboard.js';
import './client-card.js';
import './shows.js';
import './finances.js';
import './drive.js';
import './copyright.js';
import { initPortalAdmin } from './portal-admin.js';
import './settings.js';
import { initIntake } from './intake.js';
import { initClientCard } from './client-card.js';
import { initEmail } from './email.js';
import { initContacts } from './contacts.js';
import { initOnboardingWizard } from './onboarding-wizard.js';
import { initCompetition } from './competition.js';
import { initBusiness } from './business.js';
import { initStaffBus } from './staff-bus.js';
import { initDavidSidebar } from './david.js';
import './automations.js';
import { initMobileNav } from './mobile-nav.js';

// Initialize V4 modules that expose global handlers
initDashboard();
initIntake();
initClientCard();
initEmail();
initContacts();
initOnboardingWizard();
initDavidSidebar();
initCompetition();
initBusiness();
initStaffBus();
initPortalAdmin();
initMobileNav();


// ── David settings menu (API key for OpenClaw) ────────────────────────────
(async function initDavidSettings() {
  // Load key on page load
  try {
    const data = await fetch('/api/v1/agent/api-key').then(r => r.json());
    const el = document.getElementById('david-api-key-display');
    if (el) el.value = data.key || '(none — click Regenerate)';
  } catch {}
})();

window.toggleDavidMenu = function() {
  const menu = document.getElementById('david-settings-menu');
  const btn  = document.getElementById('david-indicator-btn');
  if (!menu) return;
  const isOpen = menu.style.display !== 'none';
  menu.style.display = isOpen ? 'none' : 'block';
  btn.classList.toggle('open', !isOpen);
};

window.copyDavidApiKey = function() {
  const el = document.getElementById('david-api-key-display');
  if (!el || !el.value) return;
  navigator.clipboard.writeText(el.value).then(() => {
    const btn = el.nextElementSibling;
    const orig = btn.textContent;
    btn.textContent = '✓';
    setTimeout(() => btn.textContent = orig, 1500);
  });
};

window.regenDavidApiKey = async function() {
  if (!confirm('Regenerate the OpenClaw API key? The old key will stop working immediately.')) return;
  try {
    const data = await fetch('/api/v1/agent/api-key/regenerate', { method: 'POST' }).then(r => r.json());
    const el = document.getElementById('david-api-key-display');
    if (el) el.value = data.key;
  } catch (err) {
    alert('Failed to regenerate key: ' + err.message);
  }
};

// Close menu when clicking outside
document.addEventListener('click', e => {
  const menu = document.getElementById('david-settings-menu');
  const btn  = document.getElementById('david-indicator-btn');
  if (menu && btn && !btn.contains(e.target) && !menu.contains(e.target)) {
    menu.style.display = 'none';
    btn.classList.remove('open');
  }
});

// ── Mail dropdown (4-account status pill) ────────────────────────────────
window.toggleMailMenu = function() {
  const dd = document.getElementById('mail-dropdown');
  const pill = document.getElementById('mail-status-pill');
  if (!dd) return;
  const isOpen = dd.style.display !== 'none';
  dd.style.display = isOpen ? 'none' : 'block';
  pill.classList.toggle('open', !isOpen);
};

window.mailConnect = async function(account) {
  try {
    const { url } = await fetch(`/api/v1/gmail/auth-url?account=${account}`).then(r => r.json());
    window.location.href = url;
  } catch (err) {
    alert('Could not get auth URL: ' + err.message);
  }
};

window.mailDisconnect = async function(account) {
  const labels = { wmm: 'WMM', david: 'David', personal: 'Personal' };
  if (!confirm(`Disconnect the ${labels[account] || account} Gmail account?`)) return;
  try {
    await fetch(`/api/v1/gmail/disconnect?account=${account}`, { method: 'DELETE' });
    if (typeof checkGmailStatus === 'function') checkGmailStatus();
  } catch (err) {
    alert('Disconnect failed: ' + err.message);
  }
};

// Close mail dropdown when clicking outside
document.addEventListener('click', e => {
  const dd   = document.getElementById('mail-dropdown');
  const pill = document.getElementById('mail-status-pill');
  if (dd && pill && !pill.contains(e.target) && !dd.contains(e.target)) {
    dd.style.display = 'none';
    pill.classList.remove('open');
  }
});
